var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block"},[_c('small',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":"Click to view the help guide"}},[_c('font-awesome-icon',{staticClass:"cursor-pointer ml-1 text-secondary",attrs:{"id":"helpGuide","icon":"question-circle"},on:{"click":_vm.openGuide}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }